import { isEditDataKey, isEditDataValue, isMaterialWithGas, isArticleEditData, } from "./articleeditdata";
import { clone, isInstanceOf, isTypeOrUndefined, isVertexKey, } from "./aux";
import { articleEditData, isAssembly, isManufacturablePart, isManufacturableSinglePart, isProjectEntry, } from "./documentdialog";
import { convertToWsi4Data, merge, } from "./wsi4conversion";
import { WorkStepType, getKeysOfObject, } from "./wsi4_interfaces";
import { isArray, isNumber, isString, } from "./wsi4_typeguards";
export function isStepContent(arg) {
    const typeGuardMap = {
        articleName: isString,
        materialWithGas: isMaterialWithGas,
        thickness: (t) => isTypeOrUndefined(t, isNumber),
        multiplicity: isNumber,
    };
    return isInstanceOf(arg, typeGuardMap);
}
export function isArticleWithContent(arg) {
    const typeGuardMap = {
        articleVertexKey: isVertexKey,
        content: isStepContent,
        png: (t) => isTypeOrUndefined(t, isString),
        svg: (t) => isTypeOrUndefined(t, isString),
        thicknesses: (t) => isArray(t, isNumber),
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isConversionData(arg) {
    const typeGuardMap = {
        projectEntry: isProjectEntry,
        newData: isArticleEditData,
    };
    return isInstanceOf(arg, typeGuardMap);
}
function editThickness(entry) {
    return isManufacturableSinglePart(entry) && entry.lastWorkStepType !== WorkStepType.sheetBending;
}
export function editStep(step, entry) {
    switch (step) {
        case "articleName": return true;
        case "thickness": return editThickness(entry);
        case "materialWithGas": return true;
        case "multiplicity": return true;
    }
}
function editStepOnAssembly(step) {
    switch (step) {
        case "articleName": return true;
        case "thickness": return false;
        case "materialWithGas": return false;
        case "multiplicity": return true;
    }
}
function createStepData(step, stepContent, original) {
    const key = step;
    if (!isEditDataKey(key)) {
        throw Error("Wrong type.");
    }
    const newValue = stepContent[step];
    if (!isEditDataValue(key, newValue)) {
        throw Error("Wrong type.");
    }
    const originalData = original.find(o => o.key === key);
    if (originalData === undefined) {
        throw Error("Missing original.");
    }
    return {
        new: {
            ...originalData,
            value: newValue,
        },
    };
}
function createRowStepData(step, stepContent, article, config) {
    if (!editStep(step, article)) {
        return [];
    }
    if (isManufacturableSinglePart(article) || editStepOnAssembly(step)) {
        return [
            {
                projectEntry: article,
                stepData: createStepData(step, stepContent, articleEditData(article, config)),
            },
        ];
    }
    if (!isAssembly(article)) {
        throw Error("Wrong type.");
    }
    return article.parts.reduce((res, part) => {
        if (!isManufacturablePart(part)) {
            return res;
        }
        res.push({
            projectEntry: part,
            stepData: createStepData(step, stepContent, articleEditData(part, config)),
        });
        return res;
    }, []);
}
function createRowStepDatas(stepContent, article, config) {
    return getKeysOfObject(stepContent)
        .reduce((res, step) => [
        ...res,
        ...createRowStepData(step, stepContent, article, config),
    ], []);
}
function mergeRowStepDatas(datas) {
    const conversionData = [];
    for (const d of datas) {
        let index = conversionData.findIndex(c => c.projectEntry.vertexKey === d.projectEntry.vertexKey);
        if (index === -1) {
            conversionData.push({
                newData: [],
                projectEntry: d.projectEntry,
            });
            index = conversionData.length - 1;
        }
        const data = conversionData[index];
        if (data.newData.some(n => n.key === d.stepData.new.key)) {
            throw Error("Keys dupe");
        }
        data.newData.push(d.stepData.new);
        conversionData[index] = clone(data, isConversionData);
    }
    return conversionData;
}
function generateConversionData(stepContent, projectEntry, config) {
    return mergeRowStepDatas(createRowStepDatas(stepContent, projectEntry, config));
}
export function wsi4Data(newValue, projectEntries, config) {
    const datas = newValue.flatMap(n => {
        const article = projectEntries.find(a => a.vertexKey === n.articleVertexKey);
        if (article === undefined) {
            throw Error("Missing article.");
        }
        const conversionData = generateConversionData(n.content, article, config);
        const data = conversionData.flatMap(c => convertToWsi4Data(c.projectEntry, c.newData, config));
        return merge(data);
    });
    return merge(datas);
}
